import styled from 'styled-components';
import { Label } from '../components/Modal/styles'

export const Container = styled.div`
  display: ${props => props.visible ? 'flex' : 'none'};
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 0 40px;
  padding: 0 40px;
`;

export const CombinedList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin: 14px 0;
  gap: 14px;
`;

export const RightContentLabel = styled(Label)`
  &:hover{
    cursor: pointer
  }
`;

export const EmptyAlternatives = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 8px 0 8px 18px;
  border: 1px solid ${({theme}) => theme.colors.details};
  border-radius: 4px;
`;

export const EmptyLabel = styled.label`
  margin: 0;
  color: ${({theme}) => theme.colors.text.placeholder};
  font-weight: 400;
  font-size: 15.2461px;
  line-height: 18px;
`;